export default __webpack_public_path__ + "static/1101-b18544da6cdf36bf2f3ecb0de455ac91.gif";